import { render, staticRenderFns } from "./sixTable.vue?vue&type=template&id=21b18042&scoped=true&"
import script from "./sixTable.vue?vue&type=script&lang=js&"
export * from "./sixTable.vue?vue&type=script&lang=js&"
import style0 from "./sixTable.vue?vue&type=style&index=0&id=21b18042&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b18042",
  null
  
)

export default component.exports